import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class ABExperimentService {
    static getExperimentValue(experimentId, params, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('abexperiment'),
            'getExperimentValue',
            [experimentId, params],
            additionalHeaders
        );
    }
}
